/* Potencia — additions: bench read-more + LinkedIn in bio modal + current SOQ link */
(function () {
  var SOQ_URL = "https://cdn.shopify.com/s/files/1/0578/2313/3801/files/Potencia-Partners-SOQ-10.5.26.pdf?v=1791134212";
  var SOQ_NAME = "Potencia-Partners-SOQ-10.5.26.pdf";
  document.querySelectorAll("a[data-soq]").forEach(function (a) {
    a.setAttribute("href", SOQ_URL);
    a.setAttribute("download", SOQ_NAME);
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener");
  });
  document.querySelectorAll(".bench-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var s = btn.closest(".bench");
      s.classList.toggle("open");
      btn.textContent = s.classList.contains("open") ? "Read less" : "Read more";
    });
  });
  document.querySelectorAll(".bio-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var card = btn.closest(".tm, .founder");
      if (!card) return;
      setTimeout(function () {
        var m = document.getElementById("bio-modal");
        if (!m) return;
        var oldLi = m.querySelector(".bm-head .li-link");
        if (oldLi) oldLi.remove();
        var cardLi = card.querySelector(".li-link");
        if (cardLi) {
          var host = m.querySelector(".bm-head > div");
          if (host) host.appendChild(cardLi.cloneNode(true));
        }
      }, 0);
    });
  });
})();